import styled from '@emotion/styled'

export const ModalBodyWrapper = styled.div`
  position: relative;
`
